import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelReleaseShipmentHold} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class ReleaseShipmentHoldFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId
    }
    return this.props.releaseShipmentHold(updatedValues)
      .then((response) => {
        if (response.data.releaseShipmentHold.errors.length <= 0) {
          this.props.cancelReleaseShipmentHold();
        } else {
          let errors = createValidationErrors(response.data.releaseShipmentHold.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelReleaseShipmentHold();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Releasing the hold of the shipment will allow the shipment to be started. Do you want to proceed?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const RELEASE_HOLD = gql`
  mutation releaseShipmentHold($data: ShippingIdInput!) {
    releaseShipmentHold(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(RELEASE_HOLD, {
    props: ({ mutate }) => ({
      releaseShipmentHold: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelReleaseShipmentHold})(withMutation(ReleaseShipmentHoldFormContainer));